__turbopack_context__.v({
  "body": "what-is-krails-module__FZVJja__body",
  "brandLtr": "what-is-krails-module__FZVJja__brandLtr",
  "card": "what-is-krails-module__FZVJja__card",
  "clip": "what-is-krails-module__FZVJja__clip",
  "frame": "what-is-krails-module__FZVJja__frame",
  "heading": "what-is-krails-module__FZVJja__heading",
  "headingRow": "what-is-krails-module__FZVJja__headingRow",
  "inner": "what-is-krails-module__FZVJja__inner",
  "layout": "what-is-krails-module__FZVJja__layout",
  "logo": "what-is-krails-module__FZVJja__logo",
  "logoRow": "what-is-krails-module__FZVJja__logoRow",
  "logoWrap": "what-is-krails-module__FZVJja__logoWrap",
  "mark": "what-is-krails-module__FZVJja__mark",
  "media": "what-is-krails-module__FZVJja__media",
  "mediaImage": "what-is-krails-module__FZVJja__mediaImage",
  "mediaImageBlack": "what-is-krails-module__FZVJja__mediaImageBlack",
  "mediaImageWhite": "what-is-krails-module__FZVJja__mediaImageWhite",
  "pause": "what-is-krails-module__FZVJja__pause",
  "pauseBar": "what-is-krails-module__FZVJja__pauseBar",
  "play": "what-is-krails-module__FZVJja__play",
  "prefix": "what-is-krails-module__FZVJja__prefix",
  "section": "what-is-krails-module__FZVJja__section",
  "sphere": "what-is-krails-module__FZVJja__sphere",
  "sphereVideo": "what-is-krails-module__FZVJja__sphereVideo",
  "sphereVideoPlaying": "what-is-krails-module__FZVJja__sphereVideoPlaying",
});
